import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { useFixedCouponSno } from '../../../hooks/useFixedCouponSno';
import { type GetGoodsCouponResponse, goodsService } from 'shared/src/api';
import { queryKey } from '../../../constant/queryKey';

export const useGoodsCouponRedeemAll = () => {
  const goodsSno = useGoodsSno();
  const fixedCouponSno = useFixedCouponSno();
  const client = useQueryClient();
  return useMutation({
    mutationFn: () => {
      return goodsService.postRedeemAllGoodsCoupon(goodsSno, fixedCouponSno);
    },
    onSuccess: () => {
      client.setQueryData<GetGoodsCouponResponse>(
        queryKey.goodsCouponList(goodsSno, fixedCouponSno),
        oldData => {
          if (!oldData) return oldData;

          return oldData.map(item => ({ ...item, is_issued: true }));
        },
      );
      client.invalidateQueries({
        queryKey: queryKey.goodsCoupon(goodsSno),
      });
    },
  });
};
